<script setup lang="ts">
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { useRoute } from 'vue-router'
import { useTranslate } from '@/shared/lib'
import { computed, type PropType, reactive, watch } from 'vue'
import { useLoadTypesModelList } from '@/features/Inventory/ObjectTypes/model/api.ts'
import { VSelectSearch } from '@/shared/ui'

const props = defineProps({
  field: {
    type: Object as PropType<ObjectInventoryField>,
    required: true,
  },
  hideMandatory: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update'])

const currentValues = reactive({
  object_type: props.field?.object_type || 0,
  mandatory: Boolean(props.field?.mandatory),
})

const route = useRoute()
const { trs } = useTranslate()

const objectId = computed(() => String(route.params.object_id))

const { isPending, data } = useLoadTypesModelList(objectId)

/** Вычисляем список типов **/
const modelList = computed(() => {
  return [
    { id: 0, name: trs('itf.not_set_type') },
    ...(data.value?.data || []).filter((item: any) => item.is_system),
  ]
})

/** Обновляем данные поля */
watch(currentValues, () => {
  emits('update', { ...props.field, ...currentValues })
})
</script>

<template>
  <VSelectSearch
    :items="modelList"
    :disabled="isPending"
    :label="$t('itf.select_object_type')"
    item-value="id"
    item-title="name"
    v-model="currentValues.object_type"
  />
  <VCheckbox
    v-if="!props.hideMandatory"
    class="ml-3"
    v-model="currentValues.mandatory"
    :label="$t('itf.required')"
  />
</template>
